import { Rotation, Rotations } from 'constants/directions';
import React from 'react';

interface Props {
  rotation: Rotation;
}

const rotationDirection = {
  [Rotations.LEFT]: 'translate(-930 -694) translate(920 684) translate(10 10)',
  [Rotations.RIGHT]:
    'translate(-1046 -694) translate(920 684) translate(126 10) matrix(-1 0 0 1 22 0)',
};

const RotationDirections: React.FC<Props> = ({ rotation }: Props) => {
  return (
    <svg
      height="24px"
      width="24px"
      viewBox="0 0 24 24"
      style={{ fill: '#4b585d' }}
    >
      <path
        d="M14.086 9.182c1.08 0 1.957.847 1.975 1.898V18.068c0 1.056-.865 1.914-1.94 1.932H6.975c-1.08 0-1.958-.847-1.976-1.899v-6.987c0-1.056.866-1.914 1.941-1.932h7.145zm0 1.159h-7.11c-.429 0-.777.333-.79.748v6.979c0 .419.34.76.765.773h7.135c.429 0 .777-.333.79-.749v-6.978c0-.42-.34-.76-.765-.773h-.025zm-.584-7.176c.219.214.224.558.017.78l-.017.016-.763.6C17.347 4.828 21 8.568 21 13.142c0 .32-.265.58-.593.58-.327 0-.592-.26-.592-.58 0-3.921-3.103-7.134-7.038-7.417l.725.712c.219.214.224.558.017.779l-.017.017c-.218.214-.569.22-.794.017l-.017-.017-1.668-1.636c-.219-.214-.224-.558-.017-.779l.017-.017 1.668-1.636c.224-.22.587-.22.811 0z"
        transform={rotationDirection[rotation]}
      />
    </svg>
  );
};

export default RotationDirections;
